<template>
  <div class="lesperiod">
    <el-card>
      <el-form
        :inline="true"
        :model="filter"
        ref="filter"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="课时名称" prop="name">
          <el-input
            v-model="filter.name"
            placeholder="请输入课时名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="课时类型" prop="type">
          <el-select v-model="filter.type">
            <el-option label="云直播" :value="1"></el-option>
            <el-option label="录播课" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button
        type="primary"
        size="small"
        style="margin-bottom: 10px"
        @click="dialogVisible = true"
        >新建课时</el-button
      >
      <el-table :data="list" border>
        <el-table-column
          label="课时名称"
          align="center"
          prop="name"
        ></el-table-column>
        <el-table-column label="课时类型" align="center" prop="type">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">云直播</span>
            <span v-if="scope.row.type === 2">录播课</span>
          </template>
        </el-table-column>
        <el-table-column label="开课时间" align="center" prop="beginDate">
          <template slot-scope="scope">
            <span v-if="scope.row.beginDate && scope.row.type === 1">{{
              scope.row.beginDate
            }}</span>
            <span v-if="scope.row.type === 2">--</span>
          </template>
        </el-table-column>
        <el-table-column label="结课时间" align="center" prop="endDate">
          <template slot-scope="scope">
            <span v-if="scope.row.endDate && scope.row.type === 1">{{
              scope.row.endDate
            }}</span>
            <span v-if="scope.row.type === 2">--</span>
          </template>
        </el-table-column>
        <el-table-column label="课时状态" align="center" prop="shelfFlag">
          <template slot-scope="scope">
            <span v-if="scope.row.shelfFlag === 1">已下架</span>
            <span v-if="scope.row.shelfFlag === 2">已上架</span>
          </template>
        </el-table-column>
        <el-table-column label="直播状态" align="center" prop="status">
          <template slot-scope="scope">
            <template v-if="scope.row.type === 1">
              <span v-if="scope.row.status === 10">直播未开始</span>
              <span v-if="scope.row.status === 20">直播中</span>
              <span v-if="scope.row.status === 30">直播结束</span>
              <span v-if="scope.row.status === 40">已生成回放</span>
            </template>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="教师"
          align="center"
          prop="teacherName"
        ></el-table-column>
        <el-table-column
          label="更新时间"
          align="center"
          prop="lastUpdateDate"
        ></el-table-column>
        <el-table-column label="最后操作人" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.updateByUserName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" prop="" width="200">
          <template slot-scope="scope">
            <a href="javascript:;" @click="edit(scope.row)">修改课时</a
            >&nbsp;&nbsp;
            <a href="javascript:;" @click="updateShelfFlagSpu(scope.row.id)">{{
              scope.row.shelfFlag === 1 ? '上架' : '下架'
            }}</a
            >&nbsp;&nbsp;
            <a href="javascript:;" @click="uploadDoc(scope.row)">查看课件</a
            >&nbsp;&nbsp;
            <a href="javascript:;" @click="delLesperiod(scope.row.id)">删除</a
            >&nbsp;&nbsp;
            <el-dropdown v-if="scope.row.type === 1" @command="command($event, scope.row)">
              <a class="el-dropdown-link" href="javascript:;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="editStatus">修改直播状态</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.dataStatus === 1" command="playback">拉取回放</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.dataStatus === 4" command="againPlayback">重新拉取回放</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.dataStatus === 4" command="playbackList">回放列表</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 10px; text-align: center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 添加/编辑 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :model="formItem"
        :rules="rules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="课时名称" prop="name">
          <el-input
            v-model="formItem.name"
            maxlength="50"
            placeholder="请输入课时名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="课时类型" prop="type">
          <el-radio-group v-model="formItem.type">
            <el-radio :label="2">录播课</el-radio>
            <el-radio :label="1">云直播</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="教师"
          :prop="formItem.type === 1 ? 'teacherId' : ''"
        >
          <el-select v-model="formItem.teacherId" placeholder="请选择教师">
            <el-option
              v-for="item in teacherList"
              :key="item.userId"
              :label="item.nickName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="录播课视频"
          prop="videoId"
          v-if="formItem.type === 2"
        >
          <el-input
            v-model="formItem.videoId"
            @click.native="upload1"
            readonly
            placeholder="请上传视频"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="助教"
          prop="assistantIdList"
          v-if="formItem.type === 1"
        >
          <el-select
            v-model="formItem.assistantIdList"
            style="width: 100%"
            multiple
            placeholder="可选择多个"
          >
            <el-option
              v-for="item in teacherList"
              :key="item.userId"
              :label="item.nickName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="开课时间"
          prop="beginDate"
          v-if="formItem.type === 1"
        >
          <el-date-picker
            v-model="formItem.beginDate"
            type="datetime"
            @change="beginChange"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开课时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="结课时间"
          prop="endDate"
          v-if="formItem.type === 1"
        >
          <el-date-picker
            v-model="formItem.endDate"
            type="datetime"
            @change="endChange"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结课时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="多媒体时长" prop="mediaLongFormat">
          <el-input
            v-model="formItem.mediaLongFormat"
            maxlength="6"
            placeholder="请输入多媒体时长"
          >
            <template slot="append">(min)</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="教师口令"
          prop="teacherToken"
          v-if="formItem.type === 1"
        >
          <el-input
            v-model="formItem.teacherToken"
            maxlength="9"
            placeholder="请输入教师口令"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="助教口令"
          prop="assistantToken"
          v-if="formItem.type === 1"
        >
          <el-input
            v-model="formItem.assistantToken"
            maxlength="9"
            placeholder="请输入助教口令"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="formItem.remarks"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
        <el-button type="primary" @click="onSubmit">确 认</el-button>
      </span>
    </el-dialog>

    <VideoUpload ref="VideoUpload" @childByValue="childByValue" />

    <!-- 查看课件 -->
    <LesDocUp ref="LesDocUp" />

    <!-- 修改直播状态 -->
    <EditStatus ref="EditStatus" />

    <!-- 回放列表 -->
    <PlaybackList ref="PlaybackList" />
  </div>
</template>

<script>
import {
  getList,
  addLesperiod,
  updateLesperiod,
  delLesperiod,
  updateShelfFlagSpu,
  getBaseUser,
  getMediaLongByVideoId,
  playbackLesperiod,
  againPlaybackLesperiod
} from '@/api/class/lesperiod'
import VideoUpload from '../components/video-upload.vue'

import LesDocUp from '../components/lesDocUp.vue'
import EditStatus from '../components/editStatus.vue'
import PlaybackList from '../components/playbackList.vue'
export default {
  name: 'Lesperiod',
  components: { VideoUpload, LesDocUp, EditStatus, PlaybackList },
  data() {
    return {
      filter: {
        page: 1,
        limit: 10,
        name: '',
        type: '',
      },
      list: [],
      total: 0,
      dialogVisible: false,
      title: '新增课时',
      teacherList: [],
      formItem: {
        id: '',
        name: '',
        type: 2,
        videoId: '',
        teacherId: '',
        urlVideoSource: '',
        mediaLongFormat: '',
        assistantIdList: [],
        teacherToken: '',
        assistantToken: '',
        remarks: '',
        beginDate: '',
        endDate: '',
      },
      rules: {
        name: [{ required: true, message: '请输入课时名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        teacherId: [
          { required: true, message: '请选择教师', trigger: 'change' },
        ],
        assistantIdList: [
          { required: true, message: '请选择助教', trigger: 'change' },
        ],
        videoId: [{ required: true, message: '请上传视频', trigger: 'blur' }],
        mediaLongFormat: [
          { required: true, message: '请填写多媒体时长', trigger: 'blur' },
          {
            pattern: /^(\d{1,3})|(\d{1,3}.\d{2})$/,
            message: '只能输入数字格式',
            trigger: 'blur',
          },
        ],
        beginDate: [
          { required: true, message: '请选择开课时间', trigger: 'change' },
        ],
        endDate: [
          { required: true, message: '请选择结课时间', trigger: 'change' },
        ],
        teacherToken: [
          { pattern: /^\d{1,}$/, message: '只能输入数字', trigger: 'blur' },
        ],
        assistantToken: [
          { pattern: /^\d{1,}$/, message: '只能输入数字', trigger: 'blur' },
        ],
      },
      upId: null,
    }
  },
  watch: {
    dialogVisible(nv) {
      if (nv) {
        this.getBaseUser()
      }
    },
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await getList(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    async getBaseUser() {
      const res = await getBaseUser({ page: 1, limit: -1, okTeacher: 1 })
      this.teacherList = res.data.records.filter((item) => item.status !== 0)
    },
    upload1() {
      this.$refs.VideoUpload.init()
    },
    uploadDoc(row) {
      this.$refs.LesDocUp.init(row.id, row.name)
    },
    command(type, row) {
      switch (type) {
        case 'editStatus':
          this.$refs.EditStatus.init(row)
          break
        case 'playback':
          this.playbackLesperiod(row.id)
          break
        case 'againPlayback':
          this.againPlaybackLesperiod(row.id)
          break
        case 'playbackList':
          this.$refs.PlaybackList.init(row.id)
          break
        default:
          break
      }
    },
    playbackLesperiod(id) {
      this.$confirm('确定要拉取回放吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await playbackLesperiod({id})
          this.$message.success('操作成功!')
          this.search()
        })
        .catch(() => {})
    },
    againPlaybackLesperiod(id) {
      this.$confirm('确定要重新拉取回放吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await againPlaybackLesperiod({id})
          this.$message.success('操作成功!')
          this.search()
        })
        .catch(() => {})
    },
    onSubmit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.formItem.mediaLongFormat = +this.formItem.mediaLongFormat
          if (this.formItem.id) {
            const res = await updateLesperiod(this.formItem)
          } else {
            const res = await addLesperiod(this.formItem)
          }
          this.$message.success('操作成功')
          this.handleClose()
          this.search()
        } else {
          return false
        }
      })
    },
    async updateShelfFlagSpu(id) {
      const res = await updateShelfFlagSpu({ id })
      this.$message.success('操作成功')
      this.getList()
    },
    delLesperiod(id) {
      this.$confirm('此操作将永久删除该课时, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await delLesperiod({ id })
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
          this.search()
        })
        .catch(() => {})
    },
    edit(row) {
      this.title = '编辑课时'
      Object.keys(this.formItem).forEach((key) => {
        this.formItem[key] = row[key]
      })
      this.dialogVisible = true
    },
    search() {
      this.filter.page = 1
      this.getList()
    },
    reset() {
      this.$refs.filter.resetFields()
      this.filter.page = 1
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
      this.title = '新增课时'
      // this.formItem.id = ''
      // this.$refs.form.resetFields()
      this.formItem = {
        id: '',
        name: '',
        type: 2,
        videoId: '',
        teacherId: '',
        assistantIdList: [],
        urlVideoSource: '',
        mediaLongFormat: '',
        teacherToken: '',
        assistantToken: '',
        remarks: '',
        beginDate: '',
        endDate: '',
      }
    },
    childByValue(childByValue) {
      this.formItem.videoId = childByValue[0].fileId
      this.formItem.urlVideoSource = childByValue[0].videoUrl
      this.getMediaLongByVideoId(childByValue[0].fileId)
    },
    async getMediaLongByVideoId(videoId) {
      const res = await getMediaLongByVideoId({ videoId })
      this.formItem.mediaLongFormat = res.data
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    beginChange(v) {
      if (this.formItem.endDate && v) {
        const time =
          new Date(this.formItem.endDate).getTime() - new Date(v).getTime()
        if (time > 25200000) {
          this.formItem.beginDate = ''
          this.$message.warning('开始时间与结束时间不能相差7小时以上')
        } else if (time < 0) {
          this.formItem.beginDate = ''
          this.$message.warning('开始时间不能晚于结束时间')
        }
        if (this.formItem.beginDate && this.formItem.endDate) {
          this.formItem.mediaLongFormat = (time / 1000 / 60).toFixed(2)
        } else {
          this.formItem.mediaLongFormat = ''
        }
      }
    },
    endChange(v) {
      if (this.formItem.beginDate && v) {
        const time =
          new Date(v).getTime() - new Date(this.formItem.beginDate).getTime()
        if (time > 25200000) {
          this.formItem.endDate = ''
          this.$message.warning('开始时间与结束时间不能相差7小时以上')
        } else if (time < 0) {
          this.formItem.endDate = ''
          this.$message.warning('开始时间不能晚于结束时间')
        }
        if (this.formItem.beginDate && this.formItem.endDate) {
          this.formItem.mediaLongFormat = (time / 1000 / 60).toFixed(2)
        } else {
          this.formItem.mediaLongFormat = ''
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
